import React from 'react'

import { Redirect, Route, Switch } from 'react-router-dom'

import Dashboard from '../pages/Dashboard'
import ScanProtokoly from '../pages/ScanProtokoly'
import ScanProtokolySprava from '../pages/ScanProtokolySprava'
import Zakazky from '../pages/Zakazky'
import ZakazkaForm from '../pages/ZakazkaForm'
import Zakaznici from '../pages/Zakaznici'
import ZakaznikForm from '../pages/ZakaznikForm'
import Provize from '../pages/Provize'
import PravidelneKontroly from '../pages/PravidelneKontroly'
import NezaplaceneFaktury from '../pages/NezaplaceneFaktury'

const Routes = ({ email, canViewAllJobs, accessLoaded }) => {
    return (
        <Switch>
            <Route path='/' exact render={() => <Dashboard email={email} />} />
            <Route path='/scan-protokoly' exact render={() => <ScanProtokoly email={email} />} />
            <Route path='/scan-protokoly/sprava' exact render={() => <ScanProtokolySprava email={email} />} />
            <Route path='/zakazky' exact render={() => <Zakazky email={email} />} />
            <Route path='/zakazky/nova' exact render={() => <ZakazkaForm email={email} />} />
            <Route path='/zakazky/:id' exact render={() => <ZakazkaForm email={email} />} />
            <Route path='/zakaznici' exact component={Zakaznici} />
            <Route path='/zakaznici/novy' exact component={ZakaznikForm} />
            <Route path='/zakaznici/:id' exact component={ZakaznikForm} />
            <Route path='/provize' exact render={() => {
                if (!accessLoaded) return <p>Načítám...</p>
                return canViewAllJobs ? <Provize email={email} canViewAllJobs={canViewAllJobs} /> : <Redirect to='/zakazky' />
            }} />
            <Route path='/pravidelne-kontroly' exact render={() => <PravidelneKontroly email={email} />} />
            <Route path='/nezaplacene-faktury' exact component={NezaplaceneFaktury} />
        </Switch>
    )
}

export default Routes
